import BaseServiceCrud from './BaseServiceCrud';

export default class UserActionService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'action-manage/user-action';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            actionId: criteria.actionId,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            email: criteria.email,
            name: criteria.name,
        });
    }
    getList(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
